import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';

import { TutorialService } from '../../services/tutorial.service';

@Component({
  selector: 'app-modal-tutorial',
  standalone: true,
  imports: [CommonModule, TranslateModule],
  templateUrl: './modal-tutorial.component.html',
  styleUrls: ['./modal-tutorial.component.scss']
})
export class ModalTutorialComponent {
  state$ = this.tutorialService.state$;

  constructor(private tutorialService: TutorialService) {}

  onSkip(): void {
    this.tutorialService.skip();
  }

  onBack(): void {
    this.tutorialService.back();
  }

  onNext(): void {
    this.tutorialService.next();
  }

  onFinish(): void {
    this.tutorialService.finish();
  }

  onGifError(event: Event): void {
    const img = event.target as HTMLImageElement;
    const currentSrc = img.getAttribute('src') || '';

    if (currentSrc.startsWith('/assets/')) {
      img.setAttribute('src', currentSrc.replace('/assets/', 'assets/'));
      return;
    }

    if (currentSrc.startsWith('assets/')) {
      img.setAttribute('src', `/${currentSrc}`);
      return;
    }

    img.style.display = 'none';
  }
}
